module.exports = __webpack_public_path__ + "img/Search.a8e3eda0.svg";